import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { InputBox, InputView } from '@infoods/lifebase-ui';

import { Nutrient } from '../../../../shared/components/ui-components';
import { processMeasurement } from '../../../../shared/utils/mealUtils';
import { RECIPE_MACROS } from '../constants/recipeMacros';
import { RecipeFormValues } from '../interfaces/RecipeFormValues';
import { calculateRecipeMacros } from '../utils/calculateRecipeMacros/calculateRecipeMacros';

type RecipeMacrosCardProps = {
  variant: 'perServing' | 'total';
};

const titles = {
  perServing: 'Macros per Serving',
  total: 'Total Macros',
} as const;

const RecipeMacrosCard = ({ variant }: RecipeMacrosCardProps) => {
  const { control } = useFormContext<RecipeFormValues>();
  const [ingredients, servingSize] = useWatch({
    control,
    name: ['ingredients', 'servingSize'],
  });

  const macros = calculateRecipeMacros(ingredients, servingSize);
  const variantMacros = macros[variant];

  return (
    <InputBox mode="VIEW" title={titles[variant]}>
      {RECIPE_MACROS.map(({ key, label, nutrient }) => (
        <InputView
          key={key}
          label={`${label} (${processMeasurement(nutrient)})`}
          size="medium"
          value={<Nutrient nutrient={nutrient}>{variantMacros[key]}</Nutrient>}
        />
      ))}
    </InputBox>
  );
};

export { RecipeMacrosCard };
